export default __webpack_public_path__ + "static/bg-ffd3984714bfed9a08598f1342a2a44f.png";